/**
 * vue 全局过滤器函数
 * created by leeing on 18/6/6
 */
import i18n from '@/assets/i18n'

function parseTime(time, cFormat) {
    if (arguments.length === 0) {
        return null
    }
    const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
    let date
    if (typeof time === 'object') {
        date = time
    } else {
        if (('' + time).length === 10) time = parseInt(time) * 1000
        date = new Date(time)
    }
    const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay()
    }
    const timeStr = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
        let value = formatObj[key]
        if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1]
        if (result.length > 0 && value < 10) {
            value = '0' + value
        }
        return value || 0
    })
    return timeStr
}

/**
 * 消息时间人性化转换
 */
function formatTime(time, option) {
    // time = +time * 1000
    const d = new Date(time)
    const now = Date.now()

    const diff = (now - d) / 1000

    if (diff < 30) {
        return i18n.t('c.moment')
    } else if (diff < 3600) { // less 1 hour
        return Math.ceil(diff / 60) + "" + i18n.t('c.minuteAgo')
    } else if (diff < 3600 * 24) {
        console.log(i18n)
        return Math.ceil(diff / 3600) + '' + i18n.t('c.hourAgo')
    } else if (diff < 3600 * 24 * 2) {
        return `1${i18n.t('c.dayAgo')}`
    } else if (diff < 3600 * 24 * 7) {
        let day = diff / (3600 * 24)
        return `${Math.floor(day)}${i18n.t('c.dayAgo')}`
    } else if (diff < 3600 * 24 * 31) {
        let week = diff / (3600 * 24 * 7)
        return `${Math.floor(week)}${i18n.t('c.weekAgo')}`
    } else if (diff < 3600 * 24 * 365) {
        let month = diff / (3600 * 24 * 30)
        return `${Math.floor(month)}${i18n.t('c.monthAgo')}`
    } else {
        let year = diff / (3600 * 24 * 365)
        return `${Math.floor(year)}${i18n.t('c.dayAgo')}`
    }
    if (option) {
        return parseTime(time, option)
    } else {
        return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分'
    }
}

// parse 2020-11-04 00:00:00 to 2020-11-04
function date(str) {
    let result = ''

    if (str) result = str.slice(0, 10)

    return result
}

// parse 2020-11-04 00:00:00 to 2020-11-04 00:00
function datetime(str) {
    let result = ''

    if (str) result = str.slice(0, 16)

    return result
}


/*
* 格式化文件大小, 输出成带单位的字符串
* @param {Number} size 文件大小
* @param {Number} [pointLength=2] 精确到的小数点数。
* @param {Array} [units=[ 'B', 'K', 'M', 'G', 'TB' ]] 单位数组。从字节，到千字节，一直往上指定。如果单位数组里面只指定了到了K(千字节)，同时文件大小大于M, 此方法的输出将还是显示成多少K.
* @example
* console.log( Base.formatSize( 100 ) ); // => 100B
* console.log( Base.formatSize( 1024 ) ); // => 1.00K
* console.log( Base.formatSize( 1024, 0 ) ); // => 1K
* console.log( Base.formatSize( 1024 * 1024 ) ); // => 1.00M
* console.log( Base.formatSize( 1024 * 1024 * 1024 ) ); // => 1.00G
* console.log( Base.formatSize( 1024 * 1024 * 1024, 0, ['B', 'KB', 'MB'] ) ); // => 1024MB
*/
function formatFileSize( size, pointLength, units ) {
    var unit;

    units = units || [ 'B', 'K', 'M', 'G', 'TB' ];

    while ( (unit = units.shift()) && size > 1024 ) {
        size = size / 1024;
    }

    return (unit === 'B' ? size : size.toFixed( pointLength || 2 ))+ unit;
}

/**
 * 小数点为精度问题
 * 16.69% -> 16.689999999999999%
 */
function percentNum(num) {
    return num.toFixed(2).replace(/\.0{2}$/g, '')
}

export {
    parseTime,
    formatTime,
    date,
    datetime,
    formatFileSize,
    percentNum
}
